<template>
    <Multiselect id="ms_employer" class="multiselect-locations multiselect-small" v-model="employersSelected" mode="multiple"
        :close-on-select="false" :searchable="true" :create-option="false" :object="true" :options="employersSelectable"
        :hideSelected="false" locale="de" fallback="en" @clear="clearedEmployerMultiselect" placeholder="Arbeitgeber auswählen"
        @deselect="deselectedEmployerMultiselect" @select="selectMultiselect"  />
</template>

<style>
.multiselect-locations {
    z-index: 120;
}
</style>


<script>

import Multiselect from '@vueform/multiselect';

import getEmployers from "../composables/getEmployers";

import { useEmployerStore } from "../stores/EmployerStore";

export default {

    setup() {
        const { employers, employers_error, loadEmployers } = getEmployers();
        loadEmployers();

        let employerStore = useEmployerStore();

        return { employers, employers_error, employerStore: employerStore, };

    },
    name: "MultiselectEmployers",
    components: {
        Multiselect,
    },
    props: {

    },
    emits:['selectedemployersChanged'],
    data() {
        return {
            optionSelected: "",
            employersSelected: [],
        }
    },
    mounted() {
        //console.log(this.employerStore.employers);
        this.employersSelected = this.employerStore.employers;
        let url = new URL(window.location.href);
        var params = [];
        params = url.searchParams.get('employers');
        var selectedEmployerIds = [];
        this.employersSelected.forEach(element => {
            const employerId =
                element.value
                ;
            if (employerId != []) {
                selectedEmployerIds.push(employerId);
            }
        });
    },
    watch: {
        employersSelected(newValue, oldValue) {
            this.employerStore.employers = this.employersSelected;
            this.$emit('selectedemployersChanged',this.employersSelected);
        }
    },
    computed: {
        employersSelectable() {
            var items = [];
            if (this.employers) {
                this.employers.forEach(element => {
                    const employer = {
                        value: element.id,
                        label: { en: element.name },
                    };
                    items.push(employer);
                });
            }
            return items;
        },
    },
    methods: {
        clearedEmployerMultiselect() {
            this.employersSelected = []; 

        },
        deselectedEmployerMultiselect() {
            if (this.employersSelected.length == 0) {
                this.employersSelected = [];
            }
        },
        selectMultiselect() {
            if (this.employersSelected.length > 0) {
                const allOptionSelected = this.employersSelected.find((employerSelected) => employerSelected.value == []);
                if (allOptionSelected != null) {
                    this.employersSelected = this.employersSelected.filter((employerSelected) => employerSelected.value != 9999);
                }
            }
        },
    }
}

</script>
<style scoped>
.multiselect-small {
    --ms-font-size: 0.8rem;
}
</style>>

